
export class RadWorkTypeBaseModel {
    
    id: number;
    fw_id: number;
    wt_id: number;
    wtype: string;

    constructor(
        id: number,
        fw_id: number,
        wt_id: number,
        wtype: string
    ) {
        this.id = id;
        this.fw_id = fw_id;
        this.wt_id = wt_id;
        this.wtype = wtype;
    }

    public static fromJson(json: any): RadWorkTypeBaseModel {
        return new RadWorkTypeBaseModel(
            json["id"],
            json["fw_id"],
            json["wt_id"],
            json["wtype"]
        );
    }
}